// External Libraries
import React from "react";
import * as Icon from "react-feather";

// Services
import UtilityService from "../../../services/UtilityService";

// Common Components
import WComponent from "../../common/WComponent";

const { alert } = UtilityService;

class ScheduledMeetingCard extends WComponent {
	constructor(props) {
		super(props);

		this.state = {
			copied: false,
		};
	}

	onCopyLink = async e => {
		e.stopPropagation();

		let { meeting } = this.props;
		if (!meeting.meet_link) return;

		const copied = await UtilityService.copyToClipboard({ text: meeting.meet_link });
		if (!copied) {
			alert({ type: "error", text: "Could not copy the link. Please copy it manually." });
			return;
		}

		await this.update({ copied: true });
		setTimeout(() => this.update({ copied: false }), 2000);
	};

	render() {
		let { meeting } = this.props;
		let { copied } = this.state;
		let { meeting_title, scheduled_at, meet_link, attendees } = meeting;

		const dateLabel = UtilityService.formatDate({ value: scheduled_at });
		const timeLabel = UtilityService.formatDate({ value: scheduled_at, format: "h:mm A", fallback: "" });
		const attendeeEmails = (attendees || []).map(attendee => attendee.email);

		return (
			<div className="scheduled-meeting-card">
				<div className="scheduled-meeting-card__accent" />

				<div className="scheduled-meeting-card__body">
					<div className="scheduled-meeting-card__title">{meeting_title}</div>

					<div className="scheduled-meeting-card__meta">
						<span className="scheduled-meeting-card__meta__item">
							<Icon.Calendar size={13} />
							{dateLabel}
						</span>
						{timeLabel && (
							<span className="scheduled-meeting-card__meta__item">
								<Icon.Clock size={13} />
								{timeLabel}
							</span>
						)}
						{attendeeEmails.length > 0 && (
							<span className="scheduled-meeting-card__meta__item" title={attendeeEmails.join(", ")}>
								<Icon.Users size={13} />
								{attendeeEmails.length === 1 ? attendeeEmails[0] : `${attendeeEmails.length} invitees`}
							</span>
						)}
					</div>
				</div>

				{meet_link && (
					<div className="scheduled-meeting-card__link">
						<a
							className="scheduled-meeting-card__link__url"
							href={meet_link}
							target="_blank"
							rel="noopener noreferrer"
						>
							{meet_link}
						</a>
						<button className="scheduled-meeting-card__link__copy" onClick={this.onCopyLink}>
							<Icon.Copy size={13} />
							{copied ? "Copied!" : "Copy"}
						</button>
					</div>
				)}
			</div>
		);
	}
}

export default ScheduledMeetingCard;
